import { IUsuarioCambiarPasswordModel } from "../interfaces/seguridad/IUsuarioCambiarPasswordModel";

export class UsuarioCambiarPasswordModel implements IUsuarioCambiarPasswordModel {
    oldPassword: string;
    newPassword: string;

    constructor(){
        this.oldPassword = '';
        this.newPassword = '';
    }
}